import React, { Component, useEffect, useState } from 'react';
import { Helper } from '../../../src/ToolKit/toolkit.js';

import $ from 'jquery/dist/jquery';
import { Menu, ColumnType, Action, AlertD, YesNo, DropDownBox, SelectBasic, DayTimeSelector, FormDiv, InputBox, Icon, SideView, SideItem, FilterView, SpecValues, ProTable, SimpleButton, CustomHelper, FixedMessage, Captia, Column, NewRecordValue, FromBasic, AddButton, FileProgess, LoadingBar, FromSubmit, InputTextBox, InputPasswordBox, Model, Confirm, RowState } from '../.././Componet';
import { useParams } from "react-router-dom";
import { Route, Link } from "react-router-dom";
import { Modal } from 'bootstrap';
import { DataClass, enums } from '../../../src/ToolKit/DataClass.js'
import { data, param } from 'jquery';
class EventTypeMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("EventType", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.EventTypes);
        h.Ajax('EventType', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='EventTypes' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.EventType.Id} />
                    <Column metaForInput={DataClass.EventType.Name} />
                    <Column metaForInput={DataClass.EventType.EffectType} />

                </ProTable>

            </FromSubmit>

        }

    }
}


export class PersonMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Person', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Person', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='Person' /> <ProTable Records={this.state.Records} datasourcename='Persons'>
                    <Column metaForDisplay={DataClass.Person.Id} />
                    <Column metaForDisplay={DataClass.Person.FullName} />
                    <Column metaForDisplay={DataClass.Person.Address} />
                    <Column metaForDisplay={DataClass.Person.Mobile} />
                    <Column metaForDisplay={DataClass.Person.BeforeRemain} />

                    <Action caption="ویرایش" type="Link" pageName="/Person/Edit" columnName='id' />


                    <Action caption="حذف" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}

function EditPerson() {
    const queryS = useParams();
    return <AddPerson id={queryS.id} />
}

/* درج و و یرایش رکورد */


export class AddPerson extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('Person', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('Person', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
        
            <InputBox meta={DataClass.Person.FullName} size='33%' />
            <InputBox meta={DataClass.Person.Mobile} size='33%' />
            <InputBox meta={DataClass.Person.BeforeRemain} size='33%' />

            <InputBox meta={DataClass.Person.Address} size='100%' />
          
            

        </FromSubmit>

    }

}




export class FinEventMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: true, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('FinEvent', 'Delete', { Model: record }, function (data) {
                cmd.Refersh();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('FinEvent', 'Serach', h.GetPostData(), function (data) {
            cmd.setState({ isLoaded: true, Records: data });
            h.SaveState();
        });
    }

    componentDidMount() {
        let h = new Helper();
        if (h.LoadState() == false) {
          
        }
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <InputTextBox caption="از تاریخ" columnName="from" model="from" size="25%" customHelper={CustomHelper.isDate} />
                <InputTextBox caption="تا تاریخ" columnName="to" model="to" size="25%" customHelper={CustomHelper.isDate} />
                <InputTextBox caption="از مبلغ" columnName="fromPrice" model="fromPrice" size="25%" customHelper={CustomHelper.isDigitngGroupedNumber} />
                <InputTextBox caption="تا مبلغ" columnName="toPrice" model="toPrice" size="25%" customHelper={CustomHelper.isDigitngGroupedNumber} />
                <DropDownBox caption="نام شخص" entity="Person" size="50%" includeAll={true} columnName="Person" />
                <DropDownBox caption="نوع رویداد" entity="EventType" size="50%" includeAll={true} columnName="eventTypeId" />
                <center>
                    <SimpleButton title="جستجو" onClick={this.Refersh} ></SimpleButton>
                </center>
                <AddButton title='' entity='FinEvent' /> <ProTable key={new Date().toString()} Records={this.state.Records} datasourcename='FinEvents'>
                    <Column metaForDisplay={DataClass.FinEvent.id} />
                    <Column metaForDisplay={DataClass.FinEvent.EventDate} />
                    <Column metaForDisplay={DataClass.FinEventSerachRecord.EventTypeTitle} />
                    <Column metaForDisplay={DataClass.FinEventSerachRecord.PersonTitle} />
                    
                    <Column metaForDisplay={DataClass.FinEvent.Amount} />
                    <Column metaForDisplay={DataClass.FinEvent.Descr} />
                    <Action caption="ضمیمه" Icon="Cat" type="Link" pageName="/Attachs/FinEvent" columnName="id" />

                    <Action caption="ویرایش" type="Link" pageName="/FinEvent/Edit" columnName="id" />


                    <Action caption="حذف" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}

function EditFinEvent() {
    const queryS = useParams();
    return <AddFinEvent id={queryS.id} />
}

/* درج و و یرایش رکورد */


export class AddFinEvent extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('FinEvent', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('FinEvent', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
              <InputBox meta={DataClass.FinEvent.EventDate} size='50%' />
            <InputBox meta={DataClass.FinEvent.EventTypeId} size='50%' />
            <InputBox meta={DataClass.FinEvent.Amount} size='50%' />
            <InputBox meta={DataClass.FinEvent.PersonId} size='50%' />
             
            <InputBox meta={DataClass.FinEvent.Descr} size='100%' />


        </FromSubmit>

    }

}

export class RemainPersons extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
       
        this.Refersh = this.Refersh.bind(this);

    }

    

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('SimpleAccReport', 'RemainPerson', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <ProTable Records={this.state.Records} datasourcename='PersonRemains'>
                    <Column metaForDisplay={DataClass.PersonRemain.FullName} />
                    <Column metaForDisplay={DataClass.PersonRemain.Amount} />





                </ProTable>
            </FromBasic>
        }
    }
}
export function ShowPersonDetail(props) {

    const [pageState, loadState] = useState({records:[]});
    const load = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate()) {
            h.Ajax('SimpleAccReport', 'PersonDetailTransactions', h.GetPostData(),
                (data) => {
                    loadState({ records: data });
                }

            )
        }

    };

    return <FromBasic>
        <InputBox meta={DataClass.FinEvent.PersonId} size="100%"></InputBox>
        <center>
            <SimpleButton title="جست و جو" onClick={load} Icon="View"></SimpleButton>
        </center>
        {pageState.records.length > 0 &&
            <ProTable Records={pageState.records} datasourcename='PersonDetails'>
                <Column metaForDisplay={DataClass.PersonDetail.EventDate} />
                <Column metaForDisplay={DataClass.PersonDetail.EventTypeTitle} />
                <Column metaForDisplay={DataClass.PersonDetail.Descr} />
                <Column metaForDisplay={DataClass.PersonDetail.Amount} />
                
              
                <Column metaForDisplay={DataClass.PersonDetail.Remain} />
            </ProTable>
        }
        {pageState.records.length == 0 &&
            <div>چیزی برای نمایش وجود ندارد</div>
            }
    </FromBasic>
}




export function SimpleAccountingBookApp(props) {

    let routes = [
        <Route path="DefEventTypes" element={<EventTypeMgt /> }></Route>,
        <Route path="Persons" element={<PersonMgt />} />,
<Route path="Person/Add" element={<AddPerson id="-1" />} />,
   
        <Route path="PersonRemain" element={<RemainPersons id="-1" />} />,
        <Route path="PersonDetailTran" element={<ShowPersonDetail   />} />,

        <Route path="Person/Edit/:id" element={<EditPerson />} />,
     <Route path="FinEvents" element={<FinEventMgt />} />,
<Route path="FinEvent/Add" element={<AddFinEvent id="-1" />} />,
                                           <Route path="FinEvent/Edit/:id" element={<EditFinEvent />} />

    ]
    return routes;
}